/** Identities only: no reference pH or conductivity is inferred from a chemical name. */
export const chemicalCatalog=[
 ['HCl','HCl','Acide chlorhydrique','Solutions scolaires'],
 ['H2SO4','H₂SO₄','Acide sulfurique','Solutions scolaires'],
 ['HNO3','HNO₃','Acide nitrique','Solutions scolaires'],
 ['CH3COOH','CH₃COOH','Acide éthanoïque','Solutions scolaires'],
 ['NaOH','NaOH','Hydroxyde de sodium','Solutions scolaires'],
 ['KOH','KOH','Hydroxyde de potassium','Solutions scolaires'],
 ['NH3','NH₃(aq)','Ammoniac en solution','Solutions scolaires'],
 ['NaCl','NaCl','Chlorure de sodium','Solutions scolaires'],
 ['CuSO4','CuSO₄','Sulfate de cuivre','Solutions scolaires'],
 ['AgNO3','AgNO₃','Nitrate d’argent','Solutions scolaires'],
 ['FeCl3','FeCl₃','Chlorure de fer(III)','Solutions scolaires'],
 ['Na2CO3','Na₂CO₃','Carbonate de sodium','Solutions scolaires'],
 ['NaHCO3','NaHCO₃','Hydrogénocarbonate de sodium','Solutions scolaires'],
 ['KMnO4','KMnO₄','Permanganate de potassium','Solutions scolaires'],
 ['KI','KI','Iodure de potassium','Solutions scolaires'],
 ['I2','Diiode','I₂(aq)','Solutions scolaires'],
 ['Na2S2O3','Thiosulfate de sodium','Na₂S₂O₃(aq) · ions S₂O₃²⁻','Solutions scolaires'],
 ['glucose','Glucose','C₆H₁₂O₆','Solutions scolaires'],
 ['sucrose','Saccharose','C₁₂H₂₂O₁₁','Solutions scolaires'],
 ['H2O','Eau distillée','H₂O','Eau et solvants'],
 ['ethanol','Éthanol','C₂H₆O','Eau et solvants'],
 ['acetone','Acétone','C₃H₆O','Eau et solvants'],
 ['cyclohexane','Cyclohexane','C₆H₁₂','Eau et solvants'],
 ['lemon','Jus de citron','Liquide courant','Liquides courants'],
 ['vinegar','Vinaigre','Liquide courant','Liquides courants'],
 ['soda','Soda','Liquide courant','Liquides courants'],
 ['lemonade','Limonade','Liquide courant','Liquides courants'],
 ['water','Eau','Liquide courant','Liquides courants'],
 ['sparkling-water','Eau gazeuse','Liquide courant','Liquides courants'],
 ['soap','Solution savonneuse','Liquide courant','Liquides courants'],
].map(([id,name,description,group])=>({id,name,description,group}));
export const chemicalById=Object.fromEntries(chemicalCatalog.map(c=>[c.id,c]));
export const solutionPropertyDefinitions=[
 {id:'temperatureC',label:'Température',unit:'°C'},
 {id:'densityGml',label:'Masse volumique',unit:'g·mL⁻¹'},
 {id:'absorbance',label:'Absorbance de référence',unit:''},
 {id:'wavelengthNm',label:'Longueur d’onde de référence',unit:'nm'},
] as const;
export const solutionFamily=(s:{id:string;name:string;familyId?:string})=>s.familyId??'legacy:'+s.name;
